//  @flow

import React from 'react';

//  $Ignore
import { bindActionCreators } from 'redux';
//  $Ignore
import { connect } from 'react-redux';

import { deAcitavteNotification } from '../../actions/Notification';

import Notification from './Notification';
import './style.css';

type NotifiactionProps = {
  title: string,
  description: string,
  active: boolean,
  deAcitavteNotification: () => void
};

const NotificationWrapper = (props: NotifiactionProps) => {
  const { title, description, active, deAcitavteNotification } = props;

  return (
    <Notification
      active={active}
      onClose={deAcitavteNotification}
      title={title}
      description={description}
    />
  );
};

const mapStateToProps = store => ({
  title: store.notification.title,
  description: store.notification.description,
  active: store.notification.active
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      deAcitavteNotification
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationWrapper);



// WEBPACK FOOTER //
// ./src/Components/Notification/index.js